import { render, staticRenderFns } from "./GradientBlob.vue?vue&type=template&id=16c4a670"
import script from "./GradientBlob.vue?vue&type=script&lang=js"
export * from "./GradientBlob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports